// extracted by mini-css-extract-plugin
export default {"container_fluid":"Footer_container_fluid__2d5nR","container":"Footer_container__qf6HY","footer":"Footer_footer__mA2Zv","social_media":"Footer_social_media__x7W-0"};